export default __webpack_public_path__ + "static/media/middelalder.5ebcfa49.jpg";